import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striphtml'
})

export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/<.*?>/g, ''); // replace tags
  }
}


@Pipe({
  name: 'htmlSpaces'
})

export class HtmlSpacesPipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      value = value.replace('&nbsp;', ''); // remove all spaces
    }

    return value;
  }
}
